export default __webpack_public_path__ + "static/media/The Gilded Grave.d38fe169.jpg";